// @flow
import * as actionTypes from './actions';
import type { Action } from './actions';

// Constants
import { DROPOFF_PREFERENCE_OPTIONS } from 'constants/clutchValet';

import type { IValetDetails } from './IValetDetails';
import initialState from 'store/initialState';

// Todo Rainer move this logic to WS
function reducer(
  state: IValetDetails = initialState.appointment.valetDetails,
  action: Action
): IValetDetails {
  switch (action.type) {
    case actionTypes.SET_VALET_DETAILS: {
      let dropoffPreference = DROPOFF_PREFERENCE_OPTIONS.SAME_AS_PICKUP_VALET;

      if (!action.payload.pickupDropoffSame) {
        if (action.payload.dropoffAddressType === 0) {
          dropoffPreference = DROPOFF_PREFERENCE_OPTIONS.CLUTCH_PARTIAL_VALET;
        } else {
          dropoffPreference = DROPOFF_PREFERENCE_OPTIONS.ANOTHER_LOCATION_VALET;
        }
      }

      return {
        ...action.payload,
        dropoffPreference
      };
    }
    case actionTypes.SET_DROP_OFF_ADDRESS: {
      return { ...state, dropoffAddress: action.payload };
    }
    case actionTypes.SET_DROP_OFF_ADDRESS_TYPE: {
      return { ...state, dropoffAddressType: action.payload };
    }
    case actionTypes.SET_PICK_UP_ADDRESS: {
      return { ...state, pickupAddress: action.payload };
    }
    case actionTypes.SET_PICK_UP_ADDRESS_TYPE: {
      return { ...state, pickupAddress: action.payload };
    }
    case actionTypes.SET_PHONE_NO: {
      return { ...state, phoneNo: action.payload };
    }
    case actionTypes.SET_PHONE_TYPE: {
      return { ...state, phoneType: action.payload };
    }
    case actionTypes.SET_DROPOFF_PREFERENCE: {
      return { ...state, dropoffPreference: action.payload };
    }
    case actionTypes.SET_VALET_COMMENTS: {
      return { ...state, comments: action.payload };
    }
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/valetDetails/reducer.js